import * as React      from 'react';
import { useLocation } from "react-router-dom";

type Props = {};
type State = {};

export default function ScrollToTop(): JSX.Element {
  const { pathname } = useLocation();

  React.useEffect(() => window.scrollTo(0, 0), [pathname]);

  return null;
}
